<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Reports')"></h1>
        <div class="flex justify-end items-center">
            <div class="loadingContainer" *ngIf="loadingReports || (reportsLoading | async)">
                <app-dots-loader [showLoading]="true"></app-dots-loader>
            </div>
            <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
        </div>
    </div>
    <mat-dialog-content class="w-full h-[76%] !overflow-hidden px-4 py-2 relative !left-[15px]">
        <app-reports-view [reports]="reports" [isCancelledProcess]="isCancelledProcess" (generateReport)="generateReport($event)" (printReport)="printReport($event)" (copyCheckSum)="copyReportCheckSum($event)"></app-reports-view>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
